import React, { useEffect, useState } from 'react';
import { Icon } from 'antd';
import cn from 'classnames';
import moment from 'moment';
import DateRange from '../../../../components/DateRange/DateRange';
import DateRangePickerFooter from '../../../../components/DateRangePickerFooter/DateRangePickerFooter';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import useSearchParams from '../../../../hooks/useSearchParams';
import { searchFormat, defaultPeriod } from './lib/constants';
import { isDaySame } from './lib/utils';
import { callHistoryFilters } from '../../constants/callHistoryFilters';
import styles from './SelectPeriod.module.scss';

const SelectPeriod = ({ disabled = false }) => {
  const [[fromDate, toDate], setPeriod] = useSearchParams(
    callHistoryFilters.date
  );

  const [selectedText, setSelectedText] = useState('');

  const updatePeriod = (dates) => {
    const dateStrings = dates.map((date) => date.format(searchFormat));
    setPeriod(dateStrings);
  };

  const handleRangeClick = (dates, onClose) => {
    updatePeriod(dates.range);
    onClose();
  };

  const isActiveFn = (dates) => {
    const [from, to] = dates.range;

    return isDaySame(fromDate, from) && isDaySame(toDate, to);
  };

  const hasFilter = fromDate && toDate;

  // Устанавливаем период по умолчанию, если его нет
  useEffect(() => {
    if (!hasFilter) {
      setPeriod(defaultPeriod);
    }
  }, []);

  // Задаем текст для выбранного периода
  useEffect(() => {
    let text = '';

    if (hasFilter) {
      const start = moment(fromDate).format('DD.MM.YYYY');
      const end = moment(toDate).format('DD.MM.YYYY');
      text = `${start} - ${end}`;
    }

    setSelectedText(text);
  }, [fromDate, toDate]);

  return (
    <div className={styles.root}>
      <DateRange
        onChange={updatePeriod}
        value={[moment(fromDate), moment(toDate)]}
        format="DD.MM.YYYY"
        renderButton={({ onClick }) => (
          <RoundedButton
            text="Период"
            className={cn({
              [styles.selectedBtn]: hasFilter,
            })}
            disabled={disabled}
            type="secondary"
            iconRight={<Icon type="caret-down" />}
            onClick={onClick}
          />
        )}
        renderFooter={({ onClose }) => (
          <DateRangePickerFooter
            onRangeClick={(dates) => handleRangeClick(dates, onClose)}
            isActiveFn={isActiveFn}
            rootClassName={styles.rangePickerFooter}
          />
        )}
      />
      <div
        className={cn(styles.selectedDate, {
          [styles.disabled]: disabled,
        })}
      >
        {selectedText}
      </div>
    </div>
  );
};

export default SelectPeriod;
